module.exports = __webpack_public_path__ + "static/media/controlbox.8a0c25bd.pdf";